import { useReducer } from "react";

interface CheckoutFlowState {
  isModalOpen: boolean;
  isLoading: boolean;
  isNudgeOpen: boolean;
}

type CheckoutFlowAction =
  | { type: "SET_MODAL_OPEN"; payload: boolean }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_NUDGE_OPEN"; payload: boolean };

const initialCheckoutFlowState: CheckoutFlowState = {
  isModalOpen: false,
  isLoading: false,
  isNudgeOpen: false,
};

function checkoutFlowReducer(state: CheckoutFlowState, action: CheckoutFlowAction): CheckoutFlowState {
  switch (action.type) {
    case "SET_MODAL_OPEN":
      return { ...state, isModalOpen: action.payload };
    case "SET_LOADING":
      return { ...state, isLoading: action.payload };
    case "SET_NUDGE_OPEN":
      return { ...state, isNudgeOpen: action.payload };
    default:
      return state;
  }
}

// Groups the checkout flow (unified checkout modal open state, its loading spinner,
// and the pre-checkout nudge) since handelCheckoutFunction transitions between them together.
export const useCheckoutFlowState = () => {
  const [state, dispatch] = useReducer(checkoutFlowReducer, initialCheckoutFlowState);

  return {
    isCheckoutModalOpen: state.isModalOpen,
    setIsCheckoutModalOpen: (payload: boolean) => dispatch({ type: "SET_MODAL_OPEN", payload }),
    checkOutLoader: state.isLoading,
    setCheckOutLoader: (payload: boolean) => dispatch({ type: "SET_LOADING", payload }),
    checkoutNudge: state.isNudgeOpen,
    setCheckoutNudge: (payload: boolean) => dispatch({ type: "SET_NUDGE_OPEN", payload }),
  };
};
